const a = {
  eq: (t, e) => t === e,
  neq: (t, e) => t !== e,
  beginsWith: (t, e) => t.startsWith(e),
  endsWith: (t, e) => t.endsWith(e),
  matches: (t, e) => {
    try {
      return new RegExp(`^${e}$`).test(t);
    } catch {
      return !1;
    }
  }
}, h = {
  eq: (t, e) => t === e,
  gt: (t, e) => t > e,
  lt: (t, e) => t < e
}, T = {
  eq: (t, e) => t === e
}, d = {
  containsOne: (t, e) => e.some((r) => t.includes(r)),
  containsAll: (t, e) => e.every((r) => t.includes(r)),
  isEmpty: (t) => t.length === 0
};
function S(t) {
  return new Date(
    Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate())
  ).getTime();
}
function b(t) {
  return new Date(
    Date.UTC(
      t.getUTCFullYear(),
      t.getUTCMonth(),
      t.getUTCDate(),
      23,
      59,
      59,
      999
    )
  ).getTime();
}
function m() {
  return /* @__PURE__ */ new Date();
}
const E = {
  before: (t, e) => {
    const r = m(), s = new Date(r.getTime() - e * 24 * 60 * 60 * 1e3), n = S(s);
    return t < n;
  },
  after: (t, e) => {
    const r = m(), s = new Date(r.getTime() + e * 24 * 60 * 60 * 1e3), n = b(s);
    return t > n;
  }
}, g = {
  gt: (t, e) => t > e,
  lt: (t, e) => t < e
};
function f(t, e) {
  let r;
  return t.symbol === "+" ? r = e + t.offset : r = e - t.offset, r < 0 ? r + 24 : r >= 24 ? r - 24 : r;
}
const v = {
  between: (t, e, r, s) => {
    const n = f(s, t), i = f(s, e), o = f(s, r);
    return i <= o ? n >= i && n <= o : n >= i || n <= o;
  },
  notBetween: (t, e, r, s) => !v.between(t, e, r, s)
};
function c(t, e) {
  const r = [], s = p(t, e, r), n = r.filter((i) => i.passed && i.segment !== void 0).map((i) => i.segment);
  return {
    passed: s.passed,
    segmentsPassed: n
  };
}
function p(t, e, r) {
  switch (t.type) {
    case "And":
      return D(t, e, r);
    case "Or":
      return F(t, e, r);
    case "Not":
      return I(t, e, r);
    case "StringField":
      return A(t, e);
    case "NumberField":
      return k(t, e);
    case "BooleanField":
      return R(t, e);
    case "DateField":
      return L(t, e);
    case "TimeField":
      return C(t, e);
    case "StringArrayField":
      return O(t, e);
    case "HourTimezoneField":
      return _(t, e);
    default:
      throw new Error(`Unknown expression type: ${t.type}`);
  }
}
function D(t, e, r) {
  const i = { passed: t.children.map(
    (o) => p(o, e, r)
  ).every((o) => o.passed), segment: t.segment };
  return t.segment && r.push(i), i;
}
function F(t, e, r) {
  const i = { passed: t.children.map(
    (o) => p(o, e, r)
  ).some((o) => o.passed), segment: t.segment };
  return t.segment && r.push(i), i;
}
function I(t, e, r) {
  return { passed: !p(t.child, e, r).passed };
}
function A(t, e) {
  const r = e.getString(t.fieldName);
  if (r === void 0)
    return { passed: !1 };
  let s;
  switch (t.comparator) {
    case "==":
      s = a.eq(r, t.value);
      break;
    case "!=":
      s = a.neq(r, t.value);
      break;
    case "begins_with":
      s = a.beginsWith(r, t.value);
      break;
    case "ends_with":
      s = a.endsWith(r, t.value);
      break;
    case "matches":
      s = a.matches(r, t.value);
      break;
    default:
      s = !1;
  }
  return { passed: s };
}
function k(t, e) {
  const r = e.getNumber(t.fieldName);
  if (r === void 0)
    return { passed: !1 };
  let s;
  switch (t.comparator) {
    case "==":
      s = h.eq(r, t.value);
      break;
    case ">":
      s = h.gt(r, t.value);
      break;
    case "<":
      s = h.lt(r, t.value);
      break;
    default:
      s = !1;
  }
  return { passed: s };
}
function R(t, e) {
  const r = e.getBoolean(t.fieldName);
  return r === void 0 ? { passed: !1 } : { passed: T.eq(r, t.value) };
}
function L(t, e) {
  const r = e.getLong(t.fieldName);
  if (r === void 0)
    return { passed: !1 };
  let s;
  switch (t.comparator) {
    case "before":
      s = E.before(r, t.duration.length);
      break;
    case "after":
      s = E.after(r, t.duration.length);
      break;
    default:
      s = !1;
  }
  return { passed: s };
}
function C(t, e) {
  const r = e.getInt(t.fieldName);
  if (r === void 0)
    return { passed: !1 };
  let s;
  switch (t.comparator) {
    case ">":
      s = g.gt(r, t.duration.length);
      break;
    case "<":
      s = g.lt(r, t.duration.length);
      break;
    default:
      s = !1;
  }
  return { passed: s };
}
function O(t, e) {
  const r = e.getStringList(t.fieldName);
  if (t.comparator === "is_empty")
    return { passed: r === void 0 || d.isEmpty(r) };
  if (r === void 0)
    return { passed: !1 };
  let s;
  switch (t.comparator) {
    case "contains_one":
      s = d.containsOne(r, t.values);
      break;
    case "contains_all":
      s = d.containsAll(r, t.values);
      break;
    default:
      s = !1;
  }
  return { passed: s };
}
function _(t, e) {
  const r = e.getInt(t.fieldName);
  if (r === void 0)
    return { passed: !1 };
  let s;
  switch (t.comparator) {
    case "between":
      s = v.between(
        r,
        t.hourStart,
        t.hourEnd,
        t.offset
      );
      break;
    case "not_between":
      s = v.notBetween(
        r,
        t.hourStart,
        t.hourEnd,
        t.offset
      );
      break;
    default:
      s = !1;
  }
  return { passed: s };
}
class x {
  input;
  position = 0;
  tokens = [];
  constructor(e) {
    this.input = e;
  }
  tokenize() {
    for (this.tokens = [], this.position = 0; this.position < this.input.length && (this.skipWhitespace(), !(this.position >= this.input.length)); ) {
      const e = this.nextToken();
      e && this.tokens.push(e);
    }
    return this.tokens.push({ type: "EOF", value: "", position: this.position }), this.tokens;
  }
  skipWhitespace() {
    for (; this.position < this.input.length && /\s/.test(this.input[this.position]); )
      this.position++;
  }
  peek(e = 0) {
    return this.input[this.position + e] || "";
  }
  nextToken() {
    const e = this.position, r = this.peek();
    if (r === "(")
      return this.position++, { type: "LPAREN", value: "(", position: e };
    if (r === ")")
      return this.position++, { type: "RPAREN", value: ")", position: e };
    if (r === "[")
      return this.position++, { type: "LBRACKET", value: "[", position: e };
    if (r === "]")
      return this.position++, { type: "RBRACKET", value: "]", position: e };
    if (r === ",")
      return this.position++, { type: "COMMA", value: ",", position: e };
    if (r === "+")
      return this.position++, { type: "PLUS", value: "+", position: e };
    if (r === "-" && !/\d/.test(this.peek(1)))
      return this.position++, { type: "MINUS", value: "-", position: e };
    if (r === "=" && this.peek(1) === "=")
      return this.position += 2, { type: "EQ", value: "==", position: e };
    if (r === "!" && this.peek(1) === "=")
      return this.position += 2, { type: "NEQ", value: "!=", position: e };
    if (r === ">")
      return this.position++, { type: "GT", value: ">", position: e };
    if (r === "<")
      return this.position++, { type: "LT", value: "<", position: e };
    if (r === '"' || r === "'")
      return this.readString(r);
    if (/\d/.test(r) || r === "-" && /\d/.test(this.peek(1)))
      return this.readNumber();
    if (/[a-zA-Z_]/.test(r))
      return this.readKeywordOrIdent();
    throw new Error(`Unexpected character '${r}' at position ${e}`);
  }
  readString(e) {
    const r = this.position;
    this.position++;
    let s = "";
    for (; this.position < this.input.length; ) {
      const n = this.peek();
      if (n === e)
        return this.position++, { type: "STRING", value: s, position: r };
      if (n === "\\" && this.position + 1 < this.input.length) {
        this.position++;
        const i = this.peek();
        i === "n" ? s += `
` : i === "t" ? s += "	" : i === "r" ? s += "\r" : s += i, this.position++;
      } else
        s += n, this.position++;
    }
    throw new Error(`Unterminated string starting at position ${r}`);
  }
  readNumber() {
    const e = this.position;
    let r = "";
    for (this.peek() === "-" && (r += "-", this.position++); this.position < this.input.length && /\d/.test(this.peek()); )
      r += this.peek(), this.position++;
    if (this.peek() === "." && /\d/.test(this.peek(1)))
      for (r += ".", this.position++; this.position < this.input.length && /\d/.test(this.peek()); )
        r += this.peek(), this.position++;
    return { type: "NUMBER", value: r, position: e };
  }
  readKeywordOrIdent() {
    const e = this.position;
    let r = "";
    for (; this.position < this.input.length && /[a-zA-Z0-9_-]/.test(this.peek()); )
      r += this.peek(), this.position++;
    const s = r.toUpperCase(), n = r.toLowerCase(), i = {
      sfield: "SFIELD",
      nfield: "NFIELD",
      bfield: "BFIELD",
      dfield: "DFIELD",
      tfield: "TFIELD",
      safield: "SAFIELD",
      htzfield: "HTZFIELD",
      AND: "AND",
      OR: "OR",
      NOT: "NOT",
      begins_with: "BEGINS_WITH",
      ends_with: "ENDS_WITH",
      matches: "MATCHES",
      contains_one: "CONTAINS_ONE",
      contains_all: "CONTAINS_ALL",
      is_empty: "IS_EMPTY",
      between: "BETWEEN",
      not_between: "NOT_BETWEEN",
      before: "BEFORE",
      after: "AFTER",
      days: "DAYS",
      seconds: "SECONDS",
      time_period: "TIME_PERIOD",
      segment: "SEGMENT",
      true: "TRUE",
      false: "FALSE"
    };
    return i[r] ? { type: i[r], value: r, position: e } : i[n] ? { type: i[n], value: r, position: e } : i[s] ? { type: i[s], value: r, position: e } : { type: "IDENT", value: r, position: e };
  }
}
class B {
  tokens = [];
  position = 0;
  parse(e) {
    const r = new x(e);
    this.tokens = r.tokenize(), this.position = 0;
    const s = this.parseExpr();
    if (!this.isAtEnd())
      throw new Error(
        `Unexpected token '${this.current().value}' at position ${this.current().position}`
      );
    return s;
  }
  parseExpr() {
    return this.parseLogicalOrField();
  }
  parseLogicalOrField() {
    const e = this.current();
    switch (e.type) {
      case "AND":
        return this.parseAnd();
      case "OR":
        return this.parseOr();
      case "NOT":
        return this.parseNot();
      case "SFIELD":
        return this.parseSfield();
      case "NFIELD":
        return this.parseNfield();
      case "BFIELD":
        return this.parseBfield();
      case "DFIELD":
        return this.parseDfield();
      case "TFIELD":
        return this.parseTfield();
      case "SAFIELD":
        return this.parseSafield();
      case "HTZFIELD":
        return this.parseHtzfield();
      case "LBRACKET":
        return this.parseTimePeriodPrefixedNfield();
      default:
        throw new Error(
          `Unexpected token '${e.value}' at position ${e.position}`
        );
    }
  }
  parseAnd() {
    this.expect("AND");
    const e = this.parseOptionalSegment();
    this.expect("LPAREN");
    const r = this.parseExprList();
    return this.expect("RPAREN"), { type: "And", segment: e, children: r };
  }
  parseOr() {
    this.expect("OR");
    const e = this.parseOptionalSegment();
    this.expect("LPAREN");
    const r = this.parseExprList();
    return this.expect("RPAREN"), { type: "Or", segment: e, children: r };
  }
  parseNot() {
    this.expect("NOT"), this.expect("LPAREN");
    const e = this.parseExpr();
    return this.expect("RPAREN"), { type: "Not", child: e };
  }
  parseOptionalSegment() {
    if (this.check("LBRACKET")) {
      this.advance(), this.expect("SEGMENT");
      const e = this.expect("IDENT", "NUMBER", "STRING");
      return this.expect("RBRACKET"), e.value;
    }
  }
  parseExprList() {
    const e = [];
    for (e.push(this.parseExpr()); this.check("COMMA"); )
      this.advance(), e.push(this.parseExpr());
    return e;
  }
  parseSfield() {
    this.expect("SFIELD");
    const e = this.expect("IDENT").value, r = this.parseStringComparator(), s = this.expect("STRING").value;
    return { type: "StringField", fieldName: e, comparator: r, value: s };
  }
  parseStringComparator() {
    const e = this.current();
    switch (e.type) {
      case "EQ":
        return this.advance(), "==";
      case "NEQ":
        return this.advance(), "!=";
      case "BEGINS_WITH":
        return this.advance(), "begins_with";
      case "ENDS_WITH":
        return this.advance(), "ends_with";
      case "MATCHES":
        return this.advance(), "matches";
      default:
        throw new Error(
          `Expected string comparator, got '${e.value}' at position ${e.position}`
        );
    }
  }
  parseNfield() {
    this.expect("NFIELD");
    let e;
    if (this.check("LBRACKET")) {
      this.advance(), this.expect("TIME_PERIOD");
      const i = parseFloat(this.expect("NUMBER").value);
      this.expect("DAYS"), this.expect("RBRACKET"), e = { length: i, unit: "days" };
    }
    const r = this.expect("IDENT").value, s = this.parseNumberComparator(), n = parseFloat(this.expect("NUMBER").value);
    return { type: "NumberField", fieldName: r, comparator: s, value: n, timePeriod: e };
  }
  parseTimePeriodPrefixedNfield() {
    this.expect("LBRACKET"), this.expect("TIME_PERIOD");
    const e = parseFloat(this.expect("NUMBER").value);
    this.expect("DAYS"), this.expect("RBRACKET");
    const r = { length: e, unit: "days" };
    this.expect("NFIELD");
    const s = this.expect("IDENT").value, n = this.parseNumberComparator(), i = parseFloat(this.expect("NUMBER").value);
    return { type: "NumberField", fieldName: s, comparator: n, value: i, timePeriod: r };
  }
  parseNumberComparator() {
    const e = this.current();
    switch (e.type) {
      case "EQ":
        return this.advance(), "==";
      case "GT":
        return this.advance(), ">";
      case "LT":
        return this.advance(), "<";
      default:
        throw new Error(
          `Expected number comparator, got '${e.value}' at position ${e.position}`
        );
    }
  }
  parseBfield() {
    this.expect("BFIELD");
    const e = this.expect("IDENT").value;
    this.expect("EQ");
    const r = this.current();
    let s;
    if (r.type === "TRUE")
      s = !0, this.advance();
    else if (r.type === "FALSE")
      s = !1, this.advance();
    else
      throw new Error(
        `Expected boolean value, got '${r.value}' at position ${r.position}`
      );
    return { type: "BooleanField", fieldName: e, comparator: "==", value: s };
  }
  parseDfield() {
    this.expect("DFIELD");
    const e = this.expect("IDENT").value, r = this.parseDateComparator(), s = parseFloat(this.expect("NUMBER").value);
    return this.expect("DAYS"), {
      type: "DateField",
      fieldName: e,
      comparator: r,
      duration: { length: s, unit: "days" }
    };
  }
  parseDateComparator() {
    const e = this.current();
    switch (e.type) {
      case "BEFORE":
        return this.advance(), "before";
      case "AFTER":
        return this.advance(), "after";
      default:
        throw new Error(
          `Expected date comparator (before/after), got '${e.value}' at position ${e.position}`
        );
    }
  }
  parseTfield() {
    this.expect("TFIELD");
    const e = this.expect("IDENT").value, r = this.parseTimeComparator(), s = parseFloat(this.expect("NUMBER").value);
    return this.expect("SECONDS"), {
      type: "TimeField",
      fieldName: e,
      comparator: r,
      duration: { length: s, unit: "seconds" }
    };
  }
  parseTimeComparator() {
    const e = this.current();
    switch (e.type) {
      case "GT":
        return this.advance(), ">";
      case "LT":
        return this.advance(), "<";
      default:
        throw new Error(
          `Expected time comparator (>/< ), got '${e.value}' at position ${e.position}`
        );
    }
  }
  parseSafield() {
    this.expect("SAFIELD");
    const e = this.expect("IDENT").value, r = this.parseArrayComparator();
    if (r === "is_empty")
      return { type: "StringArrayField", fieldName: e, comparator: r, values: [] };
    this.expect("LBRACKET");
    const s = [];
    if (!this.check("RBRACKET"))
      for (s.push(this.expect("STRING").value); this.check("COMMA"); )
        this.advance(), s.push(this.expect("STRING").value);
    return this.expect("RBRACKET"), { type: "StringArrayField", fieldName: e, comparator: r, values: s };
  }
  parseArrayComparator() {
    const e = this.current();
    switch (e.type) {
      case "CONTAINS_ONE":
        return this.advance(), "contains_one";
      case "CONTAINS_ALL":
        return this.advance(), "contains_all";
      case "IS_EMPTY":
        return this.advance(), "is_empty";
      default:
        throw new Error(
          `Expected array comparator, got '${e.value}' at position ${e.position}`
        );
    }
  }
  parseHtzfield() {
    this.expect("HTZFIELD");
    let e = { symbol: "+", offset: 0 };
    if (this.check("LBRACKET")) {
      this.advance();
      const o = this.current();
      if (o.type === "PLUS")
        e.symbol = "+", this.advance(), e.offset = parseFloat(this.expect("NUMBER").value);
      else if (o.type === "MINUS")
        e.symbol = "-", this.advance(), e.offset = parseFloat(this.expect("NUMBER").value);
      else if (o.type === "NUMBER") {
        const l = parseFloat(o.value);
        l < 0 ? (e.symbol = "-", e.offset = Math.abs(l)) : e.offset = l, this.advance();
      }
      this.expect("RBRACKET");
    }
    const r = this.expect("IDENT").value, s = this.parseHourComparator(), n = parseFloat(this.expect("NUMBER").value);
    this.expect("COMMA");
    const i = parseFloat(this.expect("NUMBER").value);
    return {
      type: "HourTimezoneField",
      fieldName: r,
      comparator: s,
      offset: e,
      hourStart: n,
      hourEnd: i
    };
  }
  parseHourComparator() {
    const e = this.current();
    switch (e.type) {
      case "BETWEEN":
        return this.advance(), "between";
      case "NOT_BETWEEN":
        return this.advance(), "not_between";
      default:
        throw new Error(
          `Expected hour comparator (between/not_between), got '${e.value}' at position ${e.position}`
        );
    }
  }
  // Helper methods
  current() {
    return this.tokens[this.position] || { type: "EOF", value: "", position: -1 };
  }
  isAtEnd() {
    return this.current().type === "EOF";
  }
  check(...e) {
    return e.includes(this.current().type);
  }
  advance() {
    return this.isAtEnd() || this.position++, this.tokens[this.position - 1];
  }
  expect(...e) {
    const r = this.current();
    if (!e.includes(r.type))
      throw new Error(
        `Expected ${e.join(" or ")}, got '${r.value}' at position ${r.position}`
      );
    return this.advance();
  }
}
function N(t) {
  return new B().parse(t);
}
function M(t) {
  return "field_type" in t;
}
function $(t) {
  return "logicalOp" in t;
}
function y(t) {
  const e = JSON.parse(t);
  return w(e);
}
function w(t) {
  if ($(t))
    return U(t);
  if (M(t))
    return P(t);
  throw new Error("Invalid Elevion JSON: must be a leaf or node expression");
}
function U(t) {
  const e = t.nodes.map(w), r = t.segment || void 0;
  switch (t.logicalOp) {
    case "AND":
      return { type: "And", segment: r, children: e };
    case "OR":
      return { type: "Or", segment: r, children: e };
    case "NOT":
      if (e.length !== 1)
        throw new Error("NOT expression must have exactly one child");
      return { type: "Not", child: e[0] };
    default:
      throw new Error(`Unknown logical operator: ${t.logicalOp}`);
  }
}
function P(t) {
  switch (t.field_type) {
    case "sfield":
      return z(t);
    case "nfield":
      return H(t);
    case "bfield":
      return K(t);
    case "dfield":
      return W(t);
    case "tfield":
      return G(t);
    case "safield":
      return q(t);
    case "htzfield":
      return Y(t);
    default:
      throw new Error(`Unknown field type: ${t.field_type}`);
  }
}
function z(t) {
  const e = t.comparator;
  if (!["==", "!=", "begins_with", "ends_with", "matches"].includes(e))
    throw new Error(`Invalid comparator for sfield: ${t.comparator}`);
  return {
    type: "StringField",
    fieldName: t.field,
    comparator: e,
    value: String(t.value)
  };
}
function H(t) {
  const e = t.comparator;
  if (!["==", ">", "<"].includes(e))
    throw new Error(`Invalid comparator for nfield: ${t.comparator}`);
  let r;
  if (t.data_time_period) {
    const s = t.data_time_period.match(/^(\d+)\s*days?$/i);
    s && (r = { length: parseInt(s[1], 10), unit: "days" });
  }
  return {
    type: "NumberField",
    fieldName: t.field,
    comparator: e,
    value: Number(t.value),
    timePeriod: r
  };
}
function K(t) {
  if (t.comparator !== "==")
    throw new Error(`Invalid comparator for bfield: ${t.comparator}`);
  let e;
  return typeof t.value == "boolean" ? e = t.value : typeof t.value == "string" ? e = t.value.toLowerCase() === "true" : e = !!t.value, {
    type: "BooleanField",
    fieldName: t.field,
    comparator: "==",
    value: e
  };
}
function W(t) {
  const e = t.comparator;
  if (!["before", "after"].includes(e))
    throw new Error(`Invalid comparator for dfield: ${t.comparator}`);
  const s = String(t.value).match(/^(\d+)\s*days?$/i);
  if (!s)
    throw new Error(`Invalid dfield value format: ${t.value}`);
  return {
    type: "DateField",
    fieldName: t.field,
    comparator: e,
    duration: { length: parseInt(s[1], 10), unit: "days" }
  };
}
function G(t) {
  const e = t.comparator;
  if (![">", "<"].includes(e))
    throw new Error(`Invalid comparator for tfield: ${t.comparator}`);
  const s = String(t.value).match(/^(\d+)\s*seconds?$/i);
  if (!s)
    throw new Error(`Invalid tfield value format: ${t.value}`);
  return {
    type: "TimeField",
    fieldName: t.field,
    comparator: e,
    duration: { length: parseInt(s[1], 10), unit: "seconds" }
  };
}
function q(t) {
  const e = t.comparator;
  if (!["contains_one", "contains_all", "is_empty"].includes(e))
    throw new Error(`Invalid comparator for safield: ${t.comparator}`);
  let r = [];
  return e !== "is_empty" && t.value !== null && (Array.isArray(t.value) ? r = t.value.map(String) : r = [String(t.value)]), {
    type: "StringArrayField",
    fieldName: t.field,
    comparator: e,
    values: r
  };
}
function Y(t) {
  const e = t.comparator;
  if (!["between", "not_between"].includes(e))
    throw new Error(`Invalid comparator for htzfield: ${t.comparator}`);
  let r = { symbol: "+", offset: 0 };
  if (t.tz_offset) {
    const i = t.tz_offset.match(/^([+-])(\d+)$/);
    i && (r = {
      symbol: i[1],
      offset: parseInt(i[2], 10)
    });
  }
  const n = String(t.value).match(/^(\d+)\s*,\s*(\d+)$/);
  if (!n)
    throw new Error(`Invalid htzfield value format: ${t.value}`);
  return {
    type: "HourTimezoneField",
    fieldName: t.field,
    comparator: e,
    offset: r,
    hourStart: parseInt(n[1], 10),
    hourEnd: parseInt(n[2], 10)
  };
}
function J(t) {
  return t == null ? { type: "null" } : typeof t == "string" ? { type: "string", value: t } : typeof t == "number" ? { type: "number", value: t } : typeof t == "boolean" ? { type: "boolean", value: t } : Array.isArray(t) ? { type: "stringList", value: t.filter((r) => typeof r == "string") } : { type: "null" };
}
class u {
  data;
  constructor(e) {
    this.data = /* @__PURE__ */ new Map();
    for (const [r, s] of Object.entries(e))
      this.data.set(r, J(s));
  }
  getString(e) {
    const r = this.data.get(e);
    if (r) {
      if (r.type === "string") return r.value;
      if (r.type === "number" || r.type === "boolean") return String(r.value);
    }
  }
  getNumber(e) {
    const r = this.data.get(e);
    if (r) {
      if (r.type === "number") return r.value;
      if (r.type === "string") {
        const s = parseFloat(r.value);
        return isNaN(s) ? void 0 : s;
      }
    }
  }
  getBoolean(e) {
    const r = this.data.get(e);
    if (r) {
      if (r.type === "boolean") return r.value;
      if (r.type === "string") {
        if (r.value.toLowerCase() === "true") return !0;
        if (r.value.toLowerCase() === "false") return !1;
      }
    }
  }
  getStringList(e) {
    const r = this.data.get(e);
    if (r) {
      if (r.type === "stringList") return r.value;
      if (r.type === "string") return [r.value];
    }
  }
  getInt(e) {
    const r = this.getNumber(e);
    return r !== void 0 ? Math.floor(r) : void 0;
  }
  getLong(e) {
    return this.getNumber(e);
  }
}
const Q = {
  /**
   * Parse and evaluate an Elevion DSL expression against data.
   *
   * @param expr - The Elevion DSL expression string
   * @param data - The data to evaluate against
   * @returns True if the expression passes, false otherwise
   * @throws Error if parsing fails
   */
  eval(t, e) {
    const r = N(t), s = new u(e);
    return c(r, s).passed;
  },
  /**
   * Parse and evaluate an Elevion JSON expression against data.
   *
   * @param json - The Elevion JSON expression string
   * @param data - The data to evaluate against
   * @returns True if the expression passes, false otherwise
   * @throws Error if parsing fails
   */
  evalJson(t, e) {
    const r = y(t), s = new u(e);
    return c(r, s).passed;
  },
  /**
   * Parse and evaluate an Elevion DSL expression, returning full result with
   * segments.
   *
   * @param expr - The Elevion DSL expression string
   * @param data - The data to evaluate against
   * @returns ElevionResult with passed status and segments that passed
   * @throws Error if parsing fails
   */
  evalFull(t, e) {
    const r = N(t), s = new u(e);
    return c(r, s);
  },
  /**
   * Parse and evaluate an Elevion JSON expression, returning full result with
   * segments.
   *
   * @param json - The Elevion JSON expression string
   * @param data - The data to evaluate against
   * @returns ElevionResult with passed status and segments that passed
   * @throws Error if parsing fails
   */
  evalJsonFull(t, e) {
    const r = y(t), s = new u(e);
    return c(r, s);
  }
};
export {
  Q as Elevion,
  u as ElevionMap,
  c as evaluate,
  N as parseDsl,
  y as parseJson
};
//# sourceMappingURL=index.js.map
